// components/elements/autocompleteCustom/AutocompleteCustom.jsx

import React from "react";
import { Autocomplete, TextField } from "@mui/material";
import "./autocomplete.css";

const CustomAutocomplete = ({
  label = "Select Option",
  value,
  onChange,
  options = [],
  placeholder = "",
  className = "autocomplete-custom",
  error = false,
  helperText = "",
}) => {
  return (
    <Autocomplete
      className={className}
      options={options}
      value={value}
      onChange={(event, newValue) => onChange(newValue)}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      getOptionLabel={(option) => option.label || ""}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          error={error}
          helperText={helperText}
          placeholder={placeholder}
        />
      )}
    />
  );
};

export default CustomAutocomplete;
